/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface WindowToScheduleRequest { 
    weekInterval?: number;
    endDate?: string | null;
    availabilityMode?: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    fromTime: string;
    toTime: string;
    ignoreWarnings?: boolean;
}
export namespace WindowToScheduleRequest {
}

export const WindowToScheduleRequest_weekInterval_Validators: ValidatorFn[] =
    [  Validators.min(1), Validators.max(8),];

export const WindowToScheduleRequest_endDate_Validators: ValidatorFn[] =
    [ ];

export const WindowToScheduleRequest_availabilityMode_Validators: ValidatorFn[] =
    [ ];

export const WindowToScheduleRequest_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const WindowToScheduleRequest_fromTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WindowToScheduleRequest_toTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const WindowToScheduleRequest_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];


